import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";



import { Container } from "@mui/material";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Home from "./Website/Home";
import Contact from "./Website/Contact";
import About from "./Website/About";
import Products from "./Website/Products";
import Bussiness from "./Website/Bussiness";
import Founder from "./Website/Founder";
import SunEntrepreneursLife from "./Website/SunEntrepreneursLife";
import AwardsPage from "./Website/Awards";
import Documents from "./Website/Documents";


import Login from "./components/Login";
import Register from "./components/Register";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./components/Dashboard";
import RegisterSuccess from "./components/RegisterSuccess";

import ProductDetails from "./Pages/ProductDetails";
import Cart from "./Pages/Cart";
import Wallet from "./Pages/Wallet";
import Order from "./Pages/Order";
import Referal from "./Pages/Referal";
import Tree from "./Pages/Tree";
import Myprofile from "./Pages/Myprofile";
import AwardsAchivement from "./Pages/AwardsAchivement";
import ChangePassword from "./Pages/ChangePassword";
import DailyWise from "./Pages/DailyWise";
import PaymentResult from "./Pages/PaymentResult";
import CartAndAddress from "./Pages/CartAndAddress";
import Checkout from "./Pages/Checkout";
import SubCategories from "./Pages/SubCategories";
import WalletWithdraw from "./Pages/WalletWithdraw";
import AllCategories from "./Pages/AllCategories";
import WelcomeLetter from "./Pages/WelcomeLetter";
import MyRegistration from "./Pages/MyRegistration";

import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import AdminUsers from "./admin/AdminUsers";
import AdminOrders from "./admin/AdminOrders";
import AdminProducts from "./admin/AdminProducts";
import AdminBanners from "./admin/AdminBanners";
import AdminPayments from "./admin/AdminPayments";
import AdminWalletTransactions from "./admin/AdminWalletTransactions";
import AdminPairs from "./admin/AdminPairs";
import AdminReferal from "./admin/AdminReferal";
import AdminDelivery from "./admin/AdminDelivery";
import AdminWithdraw from "./admin/AdminWithdraw";
import AdminAwards from "./admin/AdminAwards";
import AdminAchivement from "./admin/AdminAchivement";
import AdminTree from "./admin/AdminTree";
import AdminCategory from "./admin/AdminCategory";
import AdminSubcategory from "./admin/AdminSubcategory";
import AdminBilling from "./admin/AdminBilling";
import AdminContacts from "./admin/AdminContacts";
import AdminStaffOrders from "./admin/AdminStaffOrders";
import AdminReports from "./admin/AdminReports";
import AdminRegistrationStats from "./admin/AdminRegistrationStats";
import AdminStock from "./admin/AdminStock";

// ✅ Check if user is logged in
const isAuthenticated = () => {
  return !!(
    localStorage.getItem("token") ||
    localStorage.getItem("accessToken") ||
    localStorage.getItem("jwt")
  );
};

// ✅ Protect private routes — redirect to home (/) if not logged in
function AuthRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/" replace />;
}

function AppRoutes() {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith("/admin");

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <ToastContainer position="top-right" autoClose={3000} theme="light" />
      {!isAdminPath && <Navbar />}

      <div style={{ flexGrow: 1 }}>
        <Routes>

          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/products" element={<Products />} />
          <Route path="/bussiness" element={<Bussiness />} />
          <Route path="/founder" element={<Founder />} />
          <Route path="/sun-entrepreneurs-life" element={<SunEntrepreneursLife />} />
          <Route path="/awards" element={<AwardsPage />} />
          <Route path="/documents" element={<Documents />} />

          {/* ✅ PUBLIC ROUTES */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/RegisterSuccess" element={<RegisterSuccess />} />
          <Route path="/ProductDetails/:id" element={<ProductDetails />} />
          <Route path="/subcategories/:categoryId" element={<SubCategories />} />
          <Route path="/AllCategories" element={<AllCategories />} />

          {/* ✅ PROTECTED USER ROUTES */}
          <Route path="/dashboard" element={<AuthRoute><Dashboard /></AuthRoute>} />
          <Route path="/cart" element={<AuthRoute><Cart /></AuthRoute>} />
          <Route path="/wallet" element={<AuthRoute><Wallet /></AuthRoute>} />
          <Route path="/Order" element={<AuthRoute><Order /></AuthRoute>} />
          <Route path="/Referal" element={<AuthRoute><Referal /></AuthRoute>} />
          <Route path="/Tree" element={<AuthRoute><Tree /></AuthRoute>} />
          <Route path="/Myprofile" element={<AuthRoute><Myprofile /></AuthRoute>} />
          <Route path="/AwardsAchivement" element={<AuthRoute><AwardsAchivement /></AuthRoute>} />
          <Route path="/ChangePassword" element={<AuthRoute><ChangePassword /></AuthRoute>} />
          <Route path="/DailyWise" element={<AuthRoute><DailyWise /></AuthRoute>} />
          <Route path="/PaymentResult" element={<AuthRoute><PaymentResult /></AuthRoute>} />
          <Route path="/CartAndAddress" element={<AuthRoute><CartAndAddress /></AuthRoute>} />
          <Route path="/checkout" element={<AuthRoute><Checkout /></AuthRoute>} />
          <Route path="/WalletWithdraw" element={<AuthRoute><WalletWithdraw /></AuthRoute>} />
          <Route path="/WelcomeLetter" element={<AuthRoute><WelcomeLetter /></AuthRoute>} />
          <Route path="/MyRegistration" element={<AuthRoute><MyRegistration /></AuthRoute>} />

          {/* ✅ ADMIN ROUTES */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/banners" element={<AdminBanners />} />
          <Route path="/admin/payments" element={<AdminPayments />} />
          <Route path="/admin/wallet-transactions" element={<AdminWalletTransactions />} />
          <Route path="/admin/pairs" element={<AdminPairs />} />
          <Route path="/admin/referal" element={<AdminReferal />} />
          <Route path="/admin/delivery" element={<AdminDelivery />} />
          <Route path="/admin/withdraw" element={<AdminWithdraw />} />
          <Route path="/admin/awards" element={<AdminAwards />} />
          <Route path="/admin/achivement" element={<AdminAchivement />} />
          <Route path="/admin/tree" element={<AdminTree />} />
          <Route path="/admin/categories" element={<AdminCategory />} />
          <Route path="/admin/subcategories" element={<AdminSubcategory />} />
          <Route path="/admin/billing" element={<AdminBilling />} />
          <Route path="/admin/contacts" element={<AdminContacts />} />
          <Route path="/admin/staff-orders" element={<AdminStaffOrders />} />
          <Route path="/admin/reports" element={<AdminReports />} />
          <Route path="/admin/registration-stats" element={<AdminRegistrationStats />} />
          <Route path="/admin/stock" element={<AdminStock />} />

          {/* ✅ DEFAULT FALLBACK 
        <Route path="*" element={<Container sx={{ mt: 4 }}><Home /></Container>} /> */}

        </Routes>
      </div>
      {!isAdminPath && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppRoutes />
    </Router>
  );
}